import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

interface Props {
  field: Field
  leaveTypeForm: LeaveTypeFormModel
  onChange: (value: boolean) => void
}

const Attachment = ({ field, onChange }: Props) => {
  return (
    <Card extra={{ 'data-intercom-target': 'leave-type-attachment-input' }}>
      <Card.Title size="small" action={<TogglerCheckbox value={field.value} onChange={onChange} />}>
        {i18n.t('settings.leave_types.page.permissions.form.attachment.label')}
      </Card.Title>
    </Card>
  )
}

export default Attachment
